// extracted by mini-css-extract-plugin
module.exports = {"cardForm":"ListaComisiones_cardForm__2kmK7"};